<section class="contact-top videoPage">
    <p class="light">Watch our exclusive video, showcasing how UniBuild can transform operations.</p>
    <div class="video-container">
        <video #videoElement autoplay muted controls>
          <source src="https://unibuild-staticassests.unibuild.ai/Unibuild-Launch-Video.mp4" type="video/mp4">
          Your browser does not support the video tag.
        </video>
      </div>
</section>